<h1 mat-dialog-title> Save search</h1>
<div mat-dialog-content>
  <table>
    <tr>
      <td valign="top">
        <mat-card>
          <mat-card-content>

            <mat-form-field class="example-full-width" style="width: 100%;">
              <mat-label>Search name</mat-label>
              <input [(ngModel)]="searchName" matInput #name maxlength="50" required>
              <mat-hint align="end">{{name.value.length}} / 50 </mat-hint>
            </mat-form-field>

          </mat-card-content>
        </mat-card>


        <mat-card style="margin-top: 4px;">

          <mat-card-content>
            <mat-card-subtitle>
              <mat-radio-group [(ngModel)]='colorType' [ngModelOptions]="{standalone: true}">
                <mat-radio-button [value]="1">Color:</mat-radio-button>
              </mat-radio-group>
            </mat-card-subtitle>

            @if (colorType == 2) {
              <div class="bgover" style="position: absolute; top: 50px; right: 0; bottom: 0; left: 0; background-color: #fffa; z-index: 100; height: 600px;">
              </div>
            }
            <app-color-picker [color]="backgroundColor" [heading]="'Selected color'" (event)="setColor($event)" />
          </mat-card-content>

        </mat-card>
      </td>
      <td valign="top">
        <mat-card>
          <mat-card-content>
            <mat-card-subtitle>Search visible</mat-card-subtitle>

            <mat-checkbox [(ngModel)]="visibleFilters">in the claims filter</mat-checkbox>

            <br>

              <mat-checkbox [(ngModel)]="visibleMenu">in the right menu</mat-checkbox>

              <br>

                <mat-checkbox [(ngModel)]="visibleHome">on the home page</mat-checkbox>
              </mat-card-content>
            </mat-card>


            <mat-card style="margin-top: 4px;">
              <mat-card-content>
                <mat-card-subtitle>
                  <mat-radio-group [(ngModel)]='colorType' [ngModelOptions]="{standalone: true}">
                    <mat-radio-button [value]="2">Color depending on records count:</mat-radio-button>
                  </mat-radio-group>
                </mat-card-subtitle>

                <table>
                  <tr>
                    <td><button mat-button style="background-color: green; color: #fff;">Normal</button></td>
                    <td>
                      <mat-form-field style="width: 50px">
                        <mat-label>from</mat-label>
                        <input [(ngModel)]="normalFrom" matInput [disabled]="colorType == 1">
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field style="width: 50px">
                        <mat-label>to</mat-label>
                        <input [(ngModel)]="normalTo" matInput [disabled]="colorType == 1">
                      </mat-form-field>
                    </td>
                  </tr>
                  <tr>
                    <td><button mat-button style="background-color: orange; color: #fff;">Notice </button></td>
                    <td>
                      <mat-form-field style="width: 50px">
                        <mat-label>from</mat-label>
                        <input [(ngModel)]="noticeFrom" matInput [disabled]="colorType == 1">
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field style="width: 50px">
                        <mat-label>to</mat-label>
                        <input [(ngModel)]="noticeTo" matInput [disabled]="colorType == 1">
                      </mat-form-field>
                    </td>
                  </tr>
                  <tr>
                    <td><button mat-button style="background-color: red; color: #fff;">Warning</button></td>
                    <td>
                      <mat-form-field style="width: 50px">
                        <mat-label>from</mat-label>
                        <input [(ngModel)]="warningFrom" matInput [disabled]="colorType == 1">
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field style="width: 50px">
                        <mat-label>to</mat-label>
                        <input [(ngModel)]="warningTo" matInput [disabled]="colorType == 1">
                      </mat-form-field>
                    </td>
                  </tr>
                </table>

              </mat-card-content>
            </mat-card>
          </td>
        </tr>
      </table>






    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onNoClick()">Cancel</button>
      <button mat-button (click)="onOkClick()" cdkFocusInitial>Ok</button>
    </div>
